import React from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import {
	colors,
	IconButton,
	Tooltip,
} from '@mui/material';

import GetAppIcon from '@mui/icons-material/GetApp';
import BackupIcon from '@mui/icons-material/Backup';
import { Label, DataTable } from 'components';

import { DownloadFile } from 'actions/sessionActions.js';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	secondaryButton: {
		color: colors.green[800]
	},
}));

const DataTableScripting = (props) => {
	const { className, data, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();

	const _onDownloadScripts = (url) => {
		window.location.href = url;
	};

	const _onDownloadBuilderInputFiles = (url) => {
		dispatch(DownloadFile(url));
	};

	const _renderActions = (tableMeta) => {
		const { rowData } = tableMeta;
		return (
			<>
				<Tooltip title="Builder Input Files">
					<IconButton edge="end" size="small" className={classes.secondaryButton} onClick={() => _onDownloadBuilderInputFiles(rowData[8])}>
						<BackupIcon />
					</IconButton>
				</Tooltip>
				<Tooltip title="Download Scripts">
					<IconButton edge="end" size="small" className={classes.primaryButton} onClick={() => _onDownloadScripts(rowData[7])}>
						<GetAppIcon />
					</IconButton>
				</Tooltip>
			</>
		);
	};

	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'registerDate',
				label: 'Register Date',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'userName',
				label: 'User Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'fileName',
				label: 'File Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'action',
				label: 'Operation',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'status',
				label: 'Status',
				options: {
					display: true,
					filterType: 'textField',
					empty: true,
					customBodyRender: (value) => {
						if (value !== null) {
							return (
								<Label
									color={
										value === 'Success'
											? colors.green[600]
											: colors.red[600]
									}
								>
									{value}
								</Label>
							);
						}
						return null;
					}
				}
			},
			{
				name: 'actions',
				label: 'Actions',
				options: {
					filter: false,
					sort: false,
					viewColumns: false,
					empty: true,
					customBodyRender: (value, tableMeta, updateValue) => _renderActions(tableMeta)
				}
			},
			{
				name: 'urlBuilder',
				label: 'Url Builder',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'inputZipPath',
				label: 'Input Zip Path',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: false,
		expandableRows: false, // Try Adding This
		filter: false,
	});

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<DataTable
				id="scriptingTable"
				title="Scripts"
				data={data ? _.sortBy(data, item => item.registerDate).reverse() : []}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyMaxHeight="30em"
				options={_getTableOptions()}
			/>
		</div>
	);
};

DataTableScripting.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default DataTableScripting;
